import styled from 'styled-components';

export const HistoryContainer = styled.div.attrs({
    className: 'history-container'
})`
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
    height: 100%;
    scrollbar-width: thin;
    padding-bottom: 8px;
    position: relative;
    
    scroll-behavior: smooth;
    
    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: ${props => props.theme.colors.silverGrayTwo};
        border-radius: 4px;
    }
`;

export const ConversationGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const GroupTitle = styled.h3`
    position: sticky;
    background-color: ${props => props.theme.colors.white};
    top: 0;
    font-size: 14px;
    color: ${props => props.theme.colors.darkGray};
    margin: 0;
    padding: 8px 0;
    text-transform: capitalize;
`;

export const ConversationCard = styled.div`
    padding: 16px;
    height: 49px;
    background: ${props => props.theme.colors.primaryWhite};
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid transparent;

    &:hover {
        background: ${props => props.theme.colors.silverGrayThree};
    }

    &.active {
        background: ${props => props.theme.colors.silverGrayThree};
    }
    
    &.highlighted {
        background: ${props => props.theme.colors.primary100};
        border: 1px solid ${props => props.theme.colors.primary400};
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
    }
`;

export const ConversationTitle = styled.p`
    margin: 0;
    font-size: 14px;
    color: ${props => props.theme.colors.black};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 70%;
    
    .highlighted & {
        font-weight: 500;
    }
    
    strong {
        font-weight: 700;
        background-color: rgba(255, 230, 0, 0.4);
        border-radius: 2px;
        padding: 0 2px;
    }
`;

export const ConversationDate = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: ${props => props.theme.colors.darkGray};
    margin-left: 16px;
`;

export const EmptyMessage = styled.p`
    text-align: center;
    color: ${props => props.theme.colors.darkGray};
    padding: 24px;
`;

export const LoadingContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
`;
